import React from 'react';
import {
  ProFormDigit,
  ProFormSelect,
  ProFormList,
  ProFormGroup,
} from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import { SelectRole } from 'components/input';

const RoleHierarchyList = ({ name, label, ...props }) => {
  return (
    <ProFormList
      {...props}
      label={label}
      name={name}
      creatorButtonProps={{
        creatorButtonText: 'Add',
        position: 'bottom',
        type: 'dashed',
      }}
      copyIconProps={false}
      deleteIconProps={{
        tooltipText: 'delete',
      }}
      rules={[
        {
          required: true,
          message: 'please enter at least one role',
        },
      ]}
      itemContainerRender={(doms) => {
        return <ProFormGroup>{doms}</ProFormGroup>;
      }}
    >
      {(_f, index) => {
        return (
          <>
            <ProFormDigit
              label="Sequence"
              name="sequence"
              width={80}
              initialValue={index}
              tooltip="The lower the number, the higher the priority"
              min={0}
              rules={[
                {
                  required: true,
                  message: 'please enter',
                },
              ]}
            />
            <SelectRole label="Role" name="role" width="sm" />
            <ProFormSelect
              showSearch
              label="Level"
              name="level"
              width="sm"
              placeholder="level"
              valueEnum={{
                ALL: 'All',
                FACULTY: 'Faculty',
                DEPARTMENT: 'Department',
              }}
              rules={[
                {
                  required: true,
                  message: 'please select',
                },
              ]}
            />
          </>
        );
      }}
    </ProFormList>
  );
};

RoleHierarchyList.propTypes = {
  name: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
};

export default RoleHierarchyList;
